import { Popover } from "antd";
import _ from "lodash";
import React from "react";

import { POUND_SIGN } from "@/Constants/common";

import PenaltyIcon from "../../../Icons/PenaltyIcon";
import RewardIcon from "../../../Icons/RewardIcon";

/* 
Used in:
Contract Detail => shifts
Candidate Detail => upcoming & Worked [Shift View]
Unfilled => Expand View
Applied => Expand View
Booked & Worked  => Expand View [Contract View] => Shift View
*/

const ClientPayPopover = ({
  pay_arr,
  shift_rate,
  content,
  is_substitute_contract = 0,
  cover_request_awarded_penalty = "",
  cover_request_awarded_reward = "",
  clientVisitPay = 10,
  visit_charge,
}) => {
  const hasReward = cover_request_awarded_reward != "0";
  const hasPenalty = cover_request_awarded_penalty != "0";
  const showSubstituteDetails =
    is_substitute_contract && (hasReward || hasPenalty);

  const renderTableNewRow = (label, value, textColor) => (
    <tr>
      <td
        colSpan={2}
        className={`p-2 text-end text-[14px] font-medium leading-[normal] ${textColor}`}
      >
        {label}
      </td>
      <td
        className={`p-2 text-[14px] font-medium leading-[normal] ${textColor}`}
      >
        {POUND_SIGN} {Number(value).toFixed(2)}
      </td>
    </tr>
  );

  const totalClientPay = pay_arr?.reduce(
    (sum, item) => sum + Number(item.client_pay * item.unit),
    0,
  );
  const firstVisitAmount =
    pay_arr?.length > 0 ? Number(pay_arr[0].total_visit_amount_per_day) : 0;

  return (
    <Popover
      rootClassName="z-[1033] ClientPayPopover_Wrapper"
      content={
        pay_arr && _.isArray(pay_arr) ? (
          <table>
            <thead className="bg-lightblue">
              <tr>
                <th
                  className="p-2 text-left font-medium text-primary"
                  width="90px"
                >
                  Charge
                </th>
                <th
                  className="p-2 text-left font-medium text-primary"
                  width="80px"
                >
                  Unit
                </th>
                <th
                  className="p-2 text-left font-medium text-primary"
                  width="100px"
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {pay_arr.map(({ client_pay, total, unit }, index) => (
                <React.Fragment key={index}>
                  <tr className="border-b border-b-lightblue">
                    <td className="p-2 text-[14px] font-medium leading-[normal]">
                      {POUND_SIGN} {Number(client_pay).toFixed(2)}
                    </td>
                    <td className="p-2 text-[14px] font-medium leading-[normal]">
                      {unit !== "-" ? Number(unit).toFixed(2) : "0.00"}
                    </td>
                    <td className="p-2 text-[14px] font-medium leading-[normal]">
                      {POUND_SIGN} {Number(client_pay * unit).toFixed(2)}
                    </td>
                  </tr>
                </React.Fragment>
              ))}

              {firstVisitAmount
                ? renderTableNewRow(
                    "Visit Charges :",
                    firstVisitAmount,
                    "text-primary",
                  )
                : null}

              {showSubstituteDetails ? (
                <>
                  {hasReward
                    ? renderTableNewRow(
                        "Cover Reward :",
                        cover_request_awarded_reward,
                        "text-primary",
                      )
                    : null}
                  {hasPenalty
                    ? renderTableNewRow(
                        "Cover Penalty :",
                        cover_request_awarded_penalty,
                        "text-red",
                      )
                    : null}
                </>
              ) : null}

              {showSubstituteDetails || firstVisitAmount ? (
                <tr className="border-t border-t-lightblue">
                  <td
                    colSpan={2}
                    className="p-3 !text-end text-[14px] font-medium leading-[normal]"
                  >
                    {firstVisitAmount ? "Total Charges :" : "Total : "}
                  </td>
                  <td className="p-2 text-[14px] font-medium leading-[normal]">
                    {POUND_SIGN}{" "}
                    {(
                      totalClientPay +
                      firstVisitAmount +
                      Number(cover_request_awarded_reward) -
                      Number(cover_request_awarded_penalty)
                    ).toFixed(2)}
                  </td>
                </tr>
              ) : null}

              {/* {showSubstituteDetails ? (
                <>
                  {hasReward ? renderTableNewRow("Cover Reward:", cover_request_awarded_reward, "text-primary") : null}
                  {hasPenalty ? renderTableNewRow("Cover Penalty:", cover_request_awarded_penalty, "text-red") : null}
                  {renderTableNewRow("Total:", total + Number(cover_request_awarded_reward) - Number(cover_request_awarded_penalty), "")}

                </>
              ) : null} */}
            </tbody>
          </table>
        ) : null
      }
    >
      <div className="flex flex-wrap !items-center gap-1">
        {content(
          `${POUND_SIGN} ${Number.isFinite(Number(shift_rate)) ? Number(shift_rate).toFixed(2) : "0.00"}`,
        )}
        {is_substitute_contract ? (
          hasReward ? (
            <RewardIcon cls="w-[22px] h-[22px] !text-primary cursor-pointer" />
          ) : hasPenalty ? (
            <PenaltyIcon cls="w-[24px] h-[24px] !text-red cursor-pointer" />
          ) : null
        ) : null}
      </div>
    </Popover>
  );
};

export default ClientPayPopover;
